export default "/_next/static/chunks/fonts/Channel4Horseferry-Regular-16d0309bded5bc3cd27b3a4363030f6f.woff";